import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import FirewallCalc from '../components/calculators/FirewallCalc'

export default function FirewallPage() {
  return (
    <>
      <Helmet>
        <title>Azure Firewall Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure Firewall Basic, Standard, and Premium costs for UK South in GBP, including data processing and expected Log Analytics logging spend." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/firewall" />
        <meta property="og:title" content="Azure Firewall Cost Calculator UK" />
        <meta property="og:description" content="Compare Azure Firewall Basic, Standard, and Premium pricing with data processing and logging cost estimates for UK South." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/firewall" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Firewall Cost Calculator',
          description: 'Estimate Azure Firewall Basic, Standard, and Premium costs for UK South, including data processing and expected logging cost.',
          url: 'https://www.azure-calc.co.uk/firewall',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Firewall Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Basic / Standard / Premium · Data processing · Logging costs
          </p>
        </div>

        <FirewallCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>
            Related guides
          </h2>
          <Link
            to="/guides/azure-firewall-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold" style={{ color: 'var(--text-secondary)' }}>Azure Firewall Pricing Guide UK 2026</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>When Azure Firewall logging costs matter more than the Firewall itself</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
